import HeroBanner from "./homescreen/HeroBanner/HeroBanner";
import TodaysProgress from "./homescreen/TodaysProgress/TodaysProgress";
import TodaysReminders from "./homescreen/TodaysReminders/TodaysReminders";
import BookAppointment from "./homescreen/BookAppointment";
import DevicesCard from "./homescreen/DevicesCard";
import WalletCard from "./homescreen/WalletCard";
import PoweredByLogo from "./homescreen/PoweredByLogo";
import JourneyCard from "./progress/JourneyCard";
import ServicesCard from "./progress/ServicesCard";
import HealthStoreCard from "./progress/HealthStoreCard";
import EducationalContentCard from "./progress/EducationalContentCard";
import HealthProgressOverview from "./homescreen/HealthProgressOverview/HealthProgressOverview";
import QuickActionsCard from "./progress/QuickActionsCard";
import ProgramDetailsCard from "./progress/ProgramDetailsCard";

export const getComponents = (
  componentData: any,
  navigate: any,
  supportProgramKey: any,
) => {
  switch (componentData?.id) {
    case "hero-section":
      return (
        <HeroBanner {...componentData} supportProgramKey={supportProgramKey} />
      );

    case "program-details-card":
      return (
        <ProgramDetailsCard
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    case "health-progress-card":
      return <HealthProgressOverview />;

    case "today-progress-card":
      return (
        <TodaysProgress
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    case "reminders-card":
      return (
        <TodaysReminders
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    case "book-appointment-card":
      return <BookAppointment />;

    case "devices-card":
      return <DevicesCard />;

    case "wallet-card":
      return <WalletCard />;

    case "powered-by-logo":
      return (
        <PoweredByLogo
          supportProgramKey={supportProgramKey}
          imageUrl={componentData.image_url}
        />
      );

    case "journey-card":
      return <JourneyCard type={componentData.type} />;

    case "services-card":
      return (
        <ServicesCard
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    case "health-store-card":
      return <HealthStoreCard componentData={componentData} />;

    case "educational-content-card":
      return (
        <EducationalContentCard
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    case "quick-actions-card":
      return (
        <QuickActionsCard
          {...componentData}
          supportProgramKey={supportProgramKey}
        />
      );

    default:
      return null;
  }
};
